export default "__VITE_ASSET__C8A0ydjO__"